import { CourseBlock, starsList } from "../../../Pages/CourseTarget/courseBlocks";
import { mathsImg } from "./img";

/** 數學科 > 年度重點項目 */
export const mathsConcernBlocks: CourseBlock[] = [
    {
        type: "heading",
        text: "1.發展數學建模與模型思考法，提升學生邏輯思維及問題解決能力;",
        variant: "h4",
        color: "#F02602",
        sx: { pt: 2 },
    },
    {
        type: "paragraph",
        titleSize: "h5",
        data: [
            starsList([
                "於高小引入數學建模(學習建模歷程：現實情境→ 簡化假設→ 數學化建立模型→ 求解與驗證→ 修改優化)，發展數學建模的教學設計，促進學生解難能力。 ",
                "開展小三利用「模型思考法」進行應用題教學，加強學生解題和分析題目的能力(「乘除與部分」的抽象思維)。",
            ]),
        ],
        images: [mathsImg.concern2526_1, mathsImg.concern2526_2],
        position: "down",
        imageHeight: "400px",
    },

    {
        type: "heading",
        text: "2. 推動AI融入學與教，拓展個人化學習途徑，培養學生自主學習的能力。",
        variant: "h4",
        color: "#F02602",
        sx: { pt: 5 },
    },
    {
        type: "paragraph",
        titleSize: "h5",
        data: [
            starsList([
                "融入人工智能技術，提升課堂效能。",
            ]),
        ],
        images: [mathsImg.concern2627_1],
        position: "right",
        mainCardProps: {
            imgSx: { maxWidth: "800px", display: "block", margin: "0 auto" },
            noHoverAni: true,
        },
    },
    {
        type: "paragraph",
        titleSize: "h5",
        data: [
            starsList([
                "引入機器學習（Machine Learning）活動。引導學生親自訓練模型，教導電腦進行圖形分類，從中提升學生的圖形與空間感。",
            ]),
        ],
        images: [mathsImg.concern2627_2, mathsImg.concern2627_3],
        position: "down",
        imageHeight: "400px",
    },
    {
        type: "paragraph",
        titleSize: "h5",
        data: [
            starsList(["於小五、小六引入個人化學習平台(現代數學科 HKAT Mock)，以利用AI輔助學生進行個人化學習，按個人進度循序漸進學習，針對弱項作出改善。","透過定期競賽營造好玩、積極的數學學習氛圍，紮實各級運算基本功。鼓勵教師設計AI個人化評估活動，提升學生學習數學動機，定期為各級舉辦速算班際比賽，提升數學運算能力。","設計虛擬實境的AR閱讀「方」(小五)，結合先進科技促進跨學科學習（包括中文和數學），以提升學生對科普書籍的興趣和互動體驗。"]),

        ],
        images: [mathsImg.concern2526_7, mathsImg.concern2627_5],
        position: "down",
        imageHeight: "650px",
    },
    {
        type: "paragraph",
        titleSize: "h5",
        data: [
            starsList(["於「國際數學日」（Pi Day）滲入新興科技VR體驗，引發學生對新興科技的興趣。"]),
        ],
        images: [mathsImg.concern2627_6],
        position: "down",
        mainCardProps: {
            imgSx: { maxWidth: "1000px", display: "block", margin: "0 auto" },
            noHoverAni: true,
        },
    },
    {
        type: "heading",
        text: "3. 豐富學生多元學習經歷，滲透「勤學」、「孝親」價值觀教育。",
        variant: "h4",
        color: "#F02602",
        sx: { pt: 2 },
    },
    {
        type: "paragraph",
        titleSize: "h5",
        data: [
            starsList([
                "推廣服務學習與生命教育-發揚「老吾老，以及人之老」的精神，透過探訪及與長者齊玩RUMMIKUB(魔力橋)，提升學生對職業生涯規劃(社工)的認識及培養正向價值觀(孝親)。",
            ]),
        ],
        images: [mathsImg.concern2526_10],
        position: "down",
        mainCardProps: {
            imgSx: { maxWidth: "1000px", display: "block", margin: "0 auto" },
            noHoverAni: true,
        },
    },
    {
        type: "paragraph",
        titleSize: "h5",
        data: [
            starsList([
                "在教學、課業融入數學家故事及數學史，連結勤學，讓學生知道所有數學成就背後都是堅持不懈的努力。",
                "善用數學珍藏本(筆記)，記錄重點、難題、錯題及學習反思，將勤學的具體行為變成一種習慣和常規。",
                "善用「現代評核及跟進系統(MDR)」，培養學生勤奮向學，定期鞏固及跟進所學。",
            ]),
        ],
    },
];
